var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.type,on:{"click":_vm.onClick}},[_c('span',[_vm._v("[")]),_c('p',{class:{ checked: _vm.isChecked }},[_vm._v("x")]),_c('span',[_vm._v("]")]),_c('label',[_vm._v(_vm._s(_vm.label))])])}
var staticRenderFns = []

export { render, staticRenderFns }